import dynamic from 'next/dynamic'
import React, { useEffect, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'

import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import { TrendignArrow } from '@shared/components/ctIcons'
import teamImg from '@assets/images/placeholder/Placeholder_Player.svg'
const Skeleton = dynamic(() => import('@shared/components/skeleton'), { ssr: false })

function TopTennisPlayers() {
  const { t } = useTranslation()
  const [players, setPlayers] = useState([])
  const [load, setLoad] = useState(true)

  const getTopPlayers = async () => {
    try {
      const response = await fetch('https://tennis.api.oneturf.news/trending-players', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const data = await response.json()
      setPlayers(data[0]?.Players)
      setLoad(false)
    } catch (e) {
      console.log('error in fetching getTrandingPlayers for tennis api')
      setLoad(false)
    }
  }

  useEffect(() => {
    getTopPlayers()
  }, [])

  return (
    <>
      {players && players?.length > 0 && (
        <section className="widget">
          <div className="widget-title d-flex justify-content-between align-items-center">
            <h3 className="small-head d-flex align-items-center mb-0 fw-bold">{t('common:trendingPlayers')}</h3>
            <a href={'/tennis/rankings'} className="theme-text font-bold">
              {t('common:ViewAll')}
            </a>
          </div>
          <div className={`${styles.itemLink} items common-box font-semi`}>
            {players?.map(player => {
              const img = player.Img.Url
              return (
                <React.Fragment key={player?._id}>
                  <a href={`/tennis/${player?.seos[0]?.Slug}`} className={`${styles.item} item d-flex`}>
                    <div className={`${styles.playerPic} overflow-hidden rounded-circle`}>
                      <MyImage
                        src={img ? `${img}` : teamImg}
                        alt="user"
                        blurDataURL={BLUR_DATA_URL_BASE64}
                        placeholder="blur"
                        width="40"
                        height="40"
                        errorImage={teamImg}
                      />
                    </div>
                    <div className={styles.cntrText}>
                      {player?.Name}
                    </div>
                    <div className={`${styles.cntrText} mx-2`}>
                      <TrendignArrow />
                    </div>
                  </a>
                </React.Fragment>
              )
            })}
            {load &&
              [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(e => (
                <div key={e} className="bg-white py-2 py-md-3 rounded">
                  {' '}
                  <Skeleton height={'21px'} />{' '}
                </div>
              ))}
          </div>
        </section>
      )}
    </>
  )
}

export default TopTennisPlayers
